const CHAT_STREAM_API_URL = process.env.REACT_APP_CHAT_STREAM_API_URL ?? '';
const BEARER_TOKEN = process.env.REACT_APP_BEARER_TOKEN ?? '';

export const sendFeedback = async (
	appId: string,
	traceId: string,
	isLike: boolean,
	comment?: string,
): Promise<void> => {
	const apiUrl = `${CHAT_STREAM_API_URL}/feedback`;

	const response = await fetch(apiUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			bearer: `${BEARER_TOKEN}`,
			app_id: appId,
			trace_id: traceId,
		},
		body: JSON.stringify({
			score: isLike ? '1' : '0',
			comment: comment ?? '',
		}),
	});

	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
};
